import { Injectable } from '@angular/core';
import { Response, ResponseContentType } from '@angular/http';
import { HttpService, SmBaseService, PageInfo, PagedResult, ValueModel } from '../../core';
import { FilterQueryParams, IFilterQueryParams, FilterModel } from '../models/filter.models';
import { ExportOutputType } from './export.service';
import { Observable } from 'rxjs';

@Injectable()
export class ExportReportService extends SmBaseService {
	constructor(http: HttpService) {
		super(http, 'exportreport');
	}

	get(pageInfo: PageInfo, types?: string[]): Observable<PagedResult<ExportReportListModel>> {
		let filter = <IFilterQueryParams>{
			page: pageInfo.page,
			pageSize: pageInfo.pageSize,
			filter: <FilterModel>{
				items: []
			}
		};

		if (types != null) {
			let values: ValueModel[] = types.map((type: string) => {
				return { name: type, value: type };
			});

			filter.filter.items = [
				{
					id: 'jobType',
					name: 'jobType',
					values: values
				}
			];
		}

		return this._getAs<PagedResult<ExportReportListModel>>('', {
			search: FilterQueryParams.CreateUrlParamsFrom(filter)
		});
	}

	getById(id: number): Observable<ExportReportDetailModel> {
		return this._getAs<ExportReportDetailModel>(id);
	}

	getItemsFor(id: number, pageInfo: PageInfo): Observable<PagedResult<ExportReportDetailItemModel>> {
		let filter = <IFilterQueryParams>{
			page: pageInfo.page,
			pageSize: pageInfo.pageSize
		};

		return this._getAs<PagedResult<ExportReportDetailItemModel>>(`${id}/items`, {
			search: FilterQueryParams.CreateUrlParamsFrom(filter)
		});
	}

	getFile(id: number): Observable<Response> {
		return this._get(`${id}/file`, { responseType: ResponseContentType.Blob });
	}
}

export interface ExportReportListModel {
	id?: number;
	guid?: string;
	fileName?: string;
	type?: ExportOutputType;
	jobType?: string;
	createdOn?: Date;
	startedOn?: Date;
	finishedOn?: Date;
	itemsCount?: number;
	state?: string;
	internalState?: string;
}

export interface ExportReportDetailItemModel {
	id?: number;
	templateId?: number;
	templateGuid?: string;
	templateName?: string;
	aukroOfferId?: number;
	success?: boolean;
	state?: string;
	internalState?: string;
}

export interface ExportReportDetailModel {
	id?: number;
	guid?: string;
	fileName?: string;
	type?: ExportOutputType;
	jobType?: string;
	createdOn?: Date;
	startedOn?: Date;
	finishedOn?: Date;
	itemsCount?: number;
	state?: string;
	internalState?: string;
	success: boolean;
	additionalInfo: { [key: string]: any };
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/services/export-report.service.ts